import { render, staticRenderFns } from "./CollapseDelivery.vue?vue&type=template&id=3aab4e60&scoped=true&lang=pug&"
import script from "./CollapseDelivery.vue?vue&type=script&lang=js&"
export * from "./CollapseDelivery.vue?vue&type=script&lang=js&"
import style0 from "./CollapseDelivery.vue?vue&type=style&index=0&id=3aab4e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab4e60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VLayout,VProgressCircular,VRow,VSpacer})
